export const brandStatus = [
  {
    id: 1,
    name: 'Activa'
  },
  {
    id: 2,
    name: 'Inactiva'
  }
]



// WEBPACK FOOTER //
// ./src/components/designers/mocks.js